import {BaseModule} from '@kta20-core/interfaces/base-module';
import {IAppContext} from '@kta20-core/interfaces/i-app-context';
import {BridgeManager} from "@kta20-core/bridge-manager";
import {IUIBASE_BRIDGE} from "@kta20-ui-base/interfaces/i-ui-base-bridge";
import {UiBaseBridge} from "@kta20-ui-base/bridges/ui-base-bridge";
import {I18nw} from "@kta20-core/i18nweb";
import {Translation} from "@kta20-ui-base/resources/lang/en";
import {NetworkService} from "@kta20-core/net/network-service";
import {ModuleViews} from "@kta20-ui-base/view/module-views";
import {UiBaseModuleConfig} from "@kta20-ui-base/ui-base-module-config";
import {forEachAsync} from "@kta20-core/utils";
import {BaseModel} from "@kta20-core/models/base-model";
import * as Constants from "@kta20-ui-base/./constants";
import {NavigationManager} from "@kta20-ui-base/navigation-manager";
import {UiPlatformDependenciesManager} from "@kta20-ui-base/ui-platform-dependencies-manager";
import {MODULE_CLASS_NAME} from "@kta20-ui-base/./constants";
import {Translation as CoreTranslation} from "@kta20-core/resources/lang/en";
import {GlobalErrorHandler} from "@kta20-core/global-error-handler";
export {UiListComponent} from "@kta20-ui-base/comps/ui-list-component";
export {UiSearchFilterComponent} from "@kta20-ui-base/comps/ui-search-filter-component";
export {UiLongTextInputView} from "@kta20-ui-base/comps/ui-long-text-input-view";
export {UiNoRecords} from "@kta20-ui-base/comps/ui-no-records";

export class UiBaseModule extends BaseModule {

    static CLASS_NAME=MODULE_CLASS_NAME;

    static async factory(appContext: IAppContext, moduleConfig: UiBaseModuleConfig): Promise<BaseModule> {
        console.log(moduleConfig);

        this.config = moduleConfig;

        //todo: make this import platform dependent by ${appContext.platform}
        const {UiService} = await import('@kta20-ui-base/services/ui-service');

        const lang = I18nw.get().getLanguage();
        const T: Translation = (await import(`@kta20-ui-base/resources/lang/${lang}`))[lang];

        //configure global error handler to display
        //toast errors when the app throws an un-catch
        //error.
        const CTR: CoreTranslation = (await import(`@kta20-core/resources/lang/${lang}`))[lang];
        GlobalErrorHandler.get(
            window,
            'onerror',
            'onunhandledrejection',
            UiService.get(T),
            CTR
        );

        await (new UiPlatformDependenciesManager()).loadDependencies(null,async ()=>{
            //gets a concrete class from config since
            //there might be multiple implementations (web/mob)
            console.log('UI dependencies loaded');
        });

        //sets the language for all model classes so model validation
        //becomes language-aware (for strings and dates)
        BaseModel.setValidatorLanguage(I18nw.get().getLanguageAndCountryCode());

        NavigationManager
            .get(T,NetworkService.get())
            .setEventNames(Constants.VIEW_DID_LOAD_EVENT_NAME, Constants.VIEW_WILL_LOAD_EVENT_NAME);

        BridgeManager.get().addBridge(
            IUIBASE_BRIDGE,
            UiBaseBridge.factory(
                UiService.get(T),
                NavigationManager.get()
            )
        );

        await NavigationManager.get().addViews(ModuleViews);

        if(moduleConfig.viewsToPreload.length>0){
            appContext.addOnDeviceReadyListener(async ()=>{
                await forEachAsync(moduleConfig.viewsToPreload, async viewName=> await NavigationManager.get().loadView(viewName));
            });

            //depends on device elaboration capabilities
            if(appContext.isReady())
                await forEachAsync(moduleConfig.viewsToPreload, async viewName=> await NavigationManager.get().loadView(viewName));
        }
        else console.warn(
            `You are not preloading any view from UiBaseModule. 
                 If this in not intentional, check your modules config 
                 JSON file to make sure to include at-least one view.
                 You don't need to do it if you are delegating a custom
                 module the default layout of your KTA20 app.`
        );

        return new UiBaseModule;
    };

}


